module.exports = __webpack_public_path__ + "images/emoji/u5272.4a563d782bd2ff927369.png";